import React, { useState } from "react";
import { motion } from "framer-motion";
import { Play, X, ExternalLink, Music as MusicIcon, Youtube } from "lucide-react";

// Real WOLF artist links
const WOLF_SPOTIFY = "https://open.spotify.com/artist/3b0xMgt8u93GykFDiAXslc?si=zanefZxySXKyZg1kTiTFdQ";
const WOLF_SPOTIFY_ARTIST_ID = "3b0xMgt8u93GykFDiAXslc";
const WOLF_APPLE = "https://music.apple.com/au/artist/wolf/1470858095";
const WOLF_APPLE_ARTIST_ID = "1470858095";
const WOLF_YOUTUBE = "https://youtube.com/@WOLFMUSICAU";

const releases = [
  {
    id: "godwolf",
    title: "Godwolf",
    year: "Out Now",
    type: "Album",
    cover: "/godwolf-cover.jpg",
    spotify: "https://open.spotify.com/album/3JcpRUj4APrbIHzqGtgysq?si=L8yerawaTSmJ8peCMrIrOg",
    apple: "https://music.apple.com/au/album/godwolf/6798652890",
    youtube: WOLF_YOUTUBE,
    description: "Walk with the King. The new album.",
    story: "GODWOLF is the new album from WOLF — the next chapter after REBORN, and the most powerful statement yet.\n\nWhere REBORN was the resurrection, GODWOLF is what rises after: a body of work about faith, strength, surrender, and walking with the King. Forged in the dark and carried by the ocean air of the North Coast, the album brings together everything WOLF stands for — heavy cinematic rock, raw honesty, spiritual fire, and the calm alpha energy of a man who has been through the storm and came out the other side still standing.\n\nGlory be. Welcome to GODWOLF. 🐺 ✝",
    lyric: "Glory be / to the One who carried me / through the dark and back again.",
  },
  {
    id: "peace-with-teeth",
    title: "Peace With Teeth",
    year: "2026",
    type: "Album · 39 Tracks",
    cover: "/peace-with-teeth-cover.jpg",
    bandlab: "https://www.bandlab.com/wolf__reborn/albums/36b64586-b8b4-f111-a6a9-000d3a96ed93",
    youtube: WOLF_YOUTUBE,
    description: "Raw Wolf energy. Free to stream on BandLab.",
    story: "PEACE WITH TEETH — raw Wolf energy forged through faith, fire, pain and redemption. Heavy riffs, honest scars, spiritual battles and the unbreakable will to keep standing.\n\n39 tracks of unfiltered WOLF — from Carved Inside My Mind and Just Like You to Jesus Is King, Seven Still Stand and The Wolf Came Home. Streaming free, in full, on BandLab. ✝️🐺🔥",
    lyric: "Peace was never silence / it was the wolf choosing not to bite.",
    tracks: [
      "Peace With Teeth", "Carved Inside My Mind", "Just Like You", "Inevitable Addiction",
      "Cocaine Wolf", "Clarity Cuts Through the Haze", "Ancestral Bloodline", "FUCK THE NOISE",
      "Line and Sinker", "I Am Your Destiny", "Jesus Is King", "Unfiltered",
      "Seven Still Stand", "My Mona Lisa", "Bleed For The Cause", "Michael and Me",
      "I Went Intergalactic", "Heaven Is a Merry-Go-Round", "Northbound Dreams", "Angels Beside",
      "Holy Guidance", "Let the Wolf Rest", "In God's Hands", "Grace Got Loud",
      "Monster", "Heaven Got Juice", "Calm as a Wolf in His", "The Wolf Came Home",
      "Where I Get My Strength From", "I Never Left", "Gladly", "You're the Only One",
      "Guard Up, Heart Open", "Another Chapter Starts", "Complete Surrender", "A Day in the Life of",
      "Chinese Wolf", "Back in Love", "Come and Get It",
    ],
  },
  {
    id: "philida",
    title: "P.H.I.L.I.DA",
    year: "2026",
    type: "Album · 4 Tracks",
    cover: "/philida-cover.jpg",
    spotify: "https://open.spotify.com/album/0cillssU0RrTKlAgp3T9RV?si=pBEX-TdnTj2XkE0qvmjNcw",
    apple: WOLF_APPLE,
    appleSoon: true,
    youtube: WOLF_YOUTUBE,
    description: "Four songs that spell her name.",
    story: "P.H.I.L.I.DA — four songs, one name, spelled out letter by letter.\n\nSome records you write for the world. This one was written for one person. Just Like You, Carved Inside My Mind and two more — stripped back, honest, no armour. The quietest WOLF record and maybe the heaviest one. 🐺✝️",
    lyric: "I carved your name inside my mind / so even the dark can read it.",
  },
  {
    id: "cocaine-wolf",
    title: "Cocaine Wolf",
    year: "2026",
    type: "Album",
    cover: "/cocaine-wolf-cover.jpg",
    spotify: "https://open.spotify.com/album/77TbZykXR6l4aDggPlrF4t?si=nzFKykS-TB-5CbtKzgglpQ",
    apple: WOLF_APPLE,
    appleSoon: true,
    youtube: WOLF_YOUTUBE,
    description: "A higher kind of high. Same wolf. Higher level.",
    story: "COCAINE WOLF — a higher kind of high. ✝️\n\nThis isn't a record about the powder. It's about what replaced it. Faith, music, freedom, higher purpose — the rush that doesn't take anything back off you in the morning.\n\nSame wolf. Higher level.",
    lyric: "I found a higher kind of high / one that never sends the bill.",
  },
  {
    id: "no-more-fear",
    title: "No More Fear",
    year: "2026",
    type: "Album",
    cover: "/no-more-fear-cover.jpg",
    spotify: "https://open.spotify.com/album/5R6uW3ffEr6bRBni6kQjZQ?si=DBkVEVMkR3u4pRXVlqXOEw",
    apple: WOLF_APPLE,
    appleSoon: true,
    youtube: WOLF_YOUTUBE,
    description: "Fear doesn't get a seat at this table anymore.",
    story: "NO MORE FEAR — the line in the sand. ✝️🐺\n\nFear ran the show for years. Fear of failing, fear of feeling, fear of being seen. This record is the eviction notice.\n\nNot fearless — faithful. There's a difference. One pretends the storm isn't there. The other walks into it singing.",
    lyric: "No more fear / the wolf walks in the light now.",
  },
  {
    id: "inevitable-addiction",
    title: "Inevitable Addiction",
    year: "2026",
    type: "Album",
    cover: "/inevitable-addiction-cover.jpg",
    spotify: "https://open.spotify.com/album/5EOT7RW8ICuvUluSM1x469?si=KPIHcDCJTYaImbSa39dlPg",
    apple: WOLF_APPLE,
    appleSoon: true,
    youtube: WOLF_YOUTUBE,
    description: "Everybody's hooked on something. Choose yours carefully.",
    story: "INEVITABLE ADDICTION — everybody's hooked on something. ✝️🐺\n\nThe question was never whether I'd be addicted. The question was what to. This record traces the swap — the old chains for a new hunger. Music. Faith. The pack. The wave at first light.\n\nSome addictions bury you. This one raised me.",
    lyric: "Hooked on the light now / and I'm never getting clean.",
  },
  {
    id: "reborn",
    title: "Reborn",
    year: "Coming Jun 5, 2026",
    type: "Album",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/ixucow66_D15A2D70-A49B-4B34-B2A1-0D7BFAD5A4BA.png",
    spotify: "https://open.spotify.com/album/4o8mTupOqxa6MwgzDfC0St?si=fRsF4d1VS2-XjMd0iB2erw",
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "A statement. A resurrection. Out June 5.",
    story: "REBORN is the third studio album from WOLF — a raw and deeply personal body of work about awakening, identity, and reclaiming the soul that was never truly lost.\n\nWritten during one of the most transformative periods of Mark Leslie's life, REBORN captures the moment where survival turned into clarity. After years of pain, pressure, self-doubt, and searching for meaning, the album tells the story of finally waking up to the truth: the fire inside never died.\n\nBlending heavy rock energy, emotional vulnerability, spiritual undertones, and cinematic storytelling, REBORN moves through themes of grief, resilience, faith, brotherhood, love, chaos, redemption, and rebirth. Each track reflects a different chapter of the journey — from feeling disconnected and buried beneath expectation, to rediscovering creativity, purpose, and inner strength.\n\nThis album is not about becoming somebody new. It's about remembering who you were before the world told you otherwise.\n\nInspired by artists like Chris Cornell, Royal Blood, Audioslave, and The Butterfly Effect, WOLF channels raw emotion into a sound that is aggressive, soulful, reflective, and unapologetically real.\n\nREBORN is a statement. A resurrection. A reminder that even after everything — the spirit can still rise. 🐺 ✝",
    lyric: "Above me still / above me still / when the storm forgets my name / something holy carries me home.",
  },
  {
    id: "byron-air",
    title: "Byron Air",
    year: "Apr 2026",
    type: "Single",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/7qmv91n7_byron%20air%20cover%20art.jpg",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "Byron Bay. Ocean air. The moment everything changed.",
    story: "Byron Air is a deeply personal song from WOLF inspired by a surf trip to Byron Bay and the moment everything changed. It captures the feeling of meeting Ale for the first time — a connection so immediate and real that it felt like time stopped. Surrounded by ocean air, freedom, music, and endless coastline, the world suddenly felt lighter, calmer, and full of meaning. With no pressure, no fear, and no tears in the world, the song reflects a rare moment of complete peace and clarity — as if God was quietly showing the path that was always meant to be. Blending warm coastal energy with emotional honesty, Byron Air is about love, destiny, healing, and finding yourself exactly where you're supposed to be.",
    lyric: "Byron Air, yeah, hit me clean\nSalt in my lungs felt like I could breathe\nNo weight on my chest, no mask to wear\nJust me and you in the ocean air",
  },
  {
    id: "yukon-wheels",
    title: "Yukon Wheels",
    year: "Apr 2026",
    type: "Single",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/a1jshnwn_yukon%20wheels%20cover%20art.jpg",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "Windows down. North Coast roads. The person who completes you.",
    story: "Yukon Wheels is about time spent in Byron Bay with Ale — cruising around Tweed Heads and the North Coast of New South Wales with no cares in the world, windows down. It's about finding the person who completes you, doesn't judge you, and leads you back to who you really are.",
    lyric: "If you were my girlfriend, I'd never let you go\nCome take you around the world, any way you'd wanna go\nFrom the city streets to the waves down low\nYeah you already know, you already know",
  },
  {
    id: "for-you",
    title: "For You",
    year: "Apr 2026",
    type: "Single",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/ahy6c0tn_for%20you%20cover%20art.jpg",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "Every scar made sense the moment I found you.",
    story: "For You is a love song from WOLF written for Ale — the person who became destiny. Set against the ocean and the long road back from the dark, it reflects on every scar, every battle, and every quiet hour of pain that ultimately led to one moment of recognition. It's the song that says: I would walk through all of it again, because all of it was for you. Built around stripped-back vocals, warm coastal atmospheres, and emotional honesty, For You is about the kind of love that makes the journey make sense — the gratitude on the other side of survival, the realisation that the long way home was the only way you were ever going to find her. More than a love song, it's a thank-you to the ocean, to faith, and to the scars that taught you how to recognise the real thing when it arrived.",
    lyric: "Salt in my blood, yeah I feel it rise\nSun on my back, got the fire in my eyes\nCame from the dark, now I'm walking in light\nEvery scar I wear turns me into the fight",
  },
  {
    id: "nothing-missing",
    title: "Nothing Missing",
    year: "Apr 2026",
    type: "Album",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/iurenmkw_2A418EAD-D8A5-4F55-88D1-E32B846F8093.png",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "A goodbye and a rebirth. Nothing was missing all along.",
    story: "Nothing Missing is a deeply emotional chapter in the WOLF story — an album born from love, longing, illusion, and the painful beauty of finally letting go.\n\nWritten during one of the darkest and most uncertain periods of Mark Leslie's life, the album captures the experience of believing you had finally found the person, connection, or feeling that would save you from the emptiness inside. It's about holding onto hope so tightly that you ignore the signs that something was never truly meant for you.\n\nThroughout Nothing Missing, WOLF explores the tension between fantasy and reality — the desperate need to feel chosen, understood, and loved while slowly realising that some people are only chapters in your healing, not your destination. The album reflects the ache of attachment, the fear of abandonment, and the grief that comes when you finally accept that the future you imagined was never the future that was waiting for you.\n\nBut beneath the heartbreak lies something deeper: awakening.\n\nThe title Nothing Missing represents the realization that even after loss, rejection, confusion, and emotional collapse — you were never incomplete to begin with. The love you were searching for externally was something you needed to rediscover within yourself.\n\nBlending haunting melodies, raw lyrics, cinematic atmosphere, and moments of vulnerability and rage, the album stands as both a goodbye and a rebirth.\n\nIt's the sound of someone learning to stop chasing what was never theirs… and finally understanding that nothing was missing all along. 🐺",
    lyric: "There's gravity in her eyes pulling me under, no disguise\nI tried to stand, I tried to be strong\nBut I've been falling all along",
  },
  {
    id: "legend",
    title: "Legend",
    year: "Apr 2026",
    type: "Single",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/lfnb2jyc_legend%20cover%20art.jpg",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "Surviving the dark. Coming out unforgettable.",
    story: "Legend is a deeply personal anthem from WOLF about surviving the darkest moments of life and coming out stronger, wiser, and more grounded on the other side. The song reflects the emotional weight of pain, pressure, setbacks, and self-discovery — but instead of being defeated by it, turning it into purpose. Through powerful lyrics and soaring energy, Legend captures the feeling of finally backing yourself, trusting God's plan, and realizing that the hardest battles often shape who you were always meant to become. It's not about fame or ego — it's about resilience, gratitude, survival, and earning your scars with pride. Underneath the heavy sound and emotion is a message of hope: that even broken people can rise and become something unforgettable.",
    lyric: "It was all a vision, now it's real life\nThis one's for those who doubted every move I made\nBack when I was down, stuck in hospital shade",
  },
  {
    id: "wolf",
    title: "Wolf",
    year: "Mar 2026",
    type: "Album",
    cover: "https://customer-assets.emergentagent.com/job_wolf-cinematic/artifacts/pbp5yabt_IMG_2649.jpeg",
    spotify: WOLF_SPOTIFY,
    apple: WOLF_APPLE,
    youtube: WOLF_YOUTUBE,
    description: "The beginning of the rebirth story.",
    story: "Wolf is the beginning of the rebirth story — the debut album that introduced WOLF to the world through raw honesty, pain, faith, survival, and transformation. Written during one of the most defining periods of Mark Leslie's life, the album captures the search for identity, purpose, and peace after years of internal battles, chaos, pressure, and rebuilding. Across heavy riffs, emotional vocals, cinematic atmospheres, and stripped-back moments of vulnerability, Wolf explores what it means to lose yourself and slowly find your way back through music, faith, love, resilience, and truth.\n\nInspired by the emotional intensity of Chris Cornell, the raw power of Audioslave, and the modern edge of Royal Blood, the album blends alternative rock, grunge, soul, and cinematic storytelling into a deeply personal experience. Every song represents a different chapter of the journey — from darkness and isolation to clarity, healing, freedom, and spiritual awakening. More than just a debut record, Wolf is the sound of someone finally stepping into who they were always meant to become.",
    lyric: "I am who I am, I won't bend, I won't break\nIf you love me stand close, if you don't, that's okay\nI am who I am, no mask, no disguise\nI won't change for no one — I'm alive… I'm alive!",
  },
];

export default function Music() {
  const [active, setActive] = useState(null);

  return (
    <div className="pt-32 sm:pt-40 pb-20 bg-[#080808] min-h-screen" data-testid="music-page">
      <div className="max-w-[1500px] mx-auto px-6 sm:px-10 lg:px-16">
        <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37] mb-6">— Music</p>
        <h1 className="font-display wolf-gold-foil text-6xl sm:text-8xl lg:text-9xl leading-[0.85]">
          The Catalog
        </h1>
        <p className="font-editorial italic text-xl sm:text-2xl text-white/55 mt-6 max-w-2xl">
          Records, singles, and stories from the dark. Heavy atmospheric rock with ocean energy.
        </p>

        {/* RELEASE GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-10 mt-20">
          {releases.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
              className="group relative lift bg-[#161616] border border-white/10 overflow-hidden"
              data-testid={`release-card-${r.id}`}
            >
              <button
                type="button"
                onClick={() => setActive(r)}
                data-testid={`release-open-${r.id}`}
                className="block w-full text-left"
              >
                <div className="aspect-square overflow-hidden relative bg-black">
                  <img
                    src={r.cover}
                    alt={r.title}
                    className="w-full h-full object-contain transition-transform duration-[1400ms] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent pointer-events-none" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 bg-gradient-to-t from-black via-black/85 to-transparent">
                    <h3 className="font-display text-5xl sm:text-6xl text-white">{r.title}</h3>
                    <p className="font-editorial italic text-white/65 mt-2 max-w-md">{r.description}</p>
                  </div>
                </div>
              </button>

              <div className="flex border-t border-white/10">
                {r.bandlab ? (
                  <a
                    href={r.bandlab} target="_blank" rel="noreferrer"
                    data-testid={`release-bandlab-${r.id}`}
                    className="flex-[2] px-5 py-4 text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] hover:bg-white/[0.03] flex items-center justify-center gap-2 transition"
                  >
                    <MusicIcon size={12}/> Listen Free on BandLab
                  </a>
                ) : (
                <>
                <a
                  href={r.spotify} target="_blank" rel="noreferrer"
                  data-testid={`release-spotify-${r.id}`}
                  className="flex-1 px-5 py-4 text-[10px] uppercase tracking-[0.28em] text-white/70 hover:text-[#D4AF37] hover:bg-white/[0.03] flex items-center justify-center gap-2 transition"
                >
                  <MusicIcon size={12}/> Spotify
                </a>
                {r.appleSoon ? (
                  <span
                    data-testid={`release-apple-${r.id}`}
                    className="flex-1 px-5 py-4 text-[10px] uppercase tracking-[0.28em] text-white/25 flex items-center justify-center gap-2 border-l border-white/10 cursor-not-allowed"
                  >
                    Apple — Soon
                  </span>
                ) : (
                <a
                  href={r.apple} target="_blank" rel="noreferrer"
                  data-testid={`release-apple-${r.id}`}
                  className="flex-1 px-5 py-4 text-[10px] uppercase tracking-[0.28em] text-white/70 hover:text-[#D4AF37] hover:bg-white/[0.03] flex items-center justify-center gap-2 border-l border-white/10 transition"
                >
                  Apple Music
                </a>
                )}
                </>
                )}
                <a
                  href={r.youtube} target="_blank" rel="noreferrer"
                  data-testid={`release-youtube-${r.id}`}
                  className="flex-1 px-5 py-4 text-[10px] uppercase tracking-[0.28em] text-white/70 hover:text-[#D4AF37] hover:bg-white/[0.03] flex items-center justify-center gap-2 border-l border-white/10 transition"
                >
                  <Play size={12} /> YouTube
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* SPOTIFY + APPLE MUSIC */}
        <div className="mt-28">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-4">— Now playing</p>
          <h2 className="font-display text-4xl sm:text-6xl text-white mb-8">Stream The Catalog</h2>
          <div className="grid lg:grid-cols-2 gap-6">
            {/* Spotify — styled card (Spotify's own iframe currently crashes with locale bug) */}
            <a
              href={WOLF_SPOTIFY}
              target="_blank"
              rel="noreferrer"
              data-testid="spotify-card"
              className="group relative bg-[#161616] border border-white/10 hover:border-[#D4AF37]/50 overflow-hidden block"
              style={{ minHeight: 380 }}
            >
              <img
                src="/wolfpack-gold.png"
                alt="WOLF on Spotify"
                className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity duration-[1200ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black via-black/85 to-transparent" />
              <div className="relative h-full p-7 sm:p-9 flex flex-col justify-between min-h-[380px]">
                <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/90">— Spotify</p>
                <div>
                  <MusicIcon size={28} className="text-[#D4AF37] mb-4" />
                  <p className="font-display text-4xl sm:text-5xl text-white tracking-tight leading-[0.95]">
                    Listen on<br />Spotify
                  </p>
                  <p className="font-editorial italic text-white/65 mt-3 max-w-sm">
                    Full catalog, singles, and the latest drops on the official WOLF artist page.
                  </p>
                  <span className="mt-6 text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] inline-flex items-center gap-2 border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-4 py-2">
                    Open Spotify <ExternalLink size={12} />
                  </span>
                </div>
              </div>
            </a>

            {/* Apple Music — official embed */}
            <div className="bg-[#161616] border border-white/10 p-2 flex flex-col">
              <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/80 px-3 pt-2 pb-3">— Apple Music</p>
              <iframe
                data-testid="apple-embed"
                allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
                frameBorder="0"
                height="350"
                style={{ width: "100%", overflow: "hidden", background: "transparent", flex: 1 }}
                src={`https://embed.music.apple.com/au/artist/wolf/${WOLF_APPLE_ARTIST_ID}`}
                loading="lazy"
                title="WOLF on Apple Music"
              />
            </div>
          </div>
        </div>

        {/* YOUTUBE CHANNEL CTA */}
        <div className="mt-28">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-4">— Visuals</p>
          <h2 className="font-display text-4xl sm:text-6xl text-white mb-8">Live & Studio</h2>
          <a
            href={WOLF_YOUTUBE}
            target="_blank"
            rel="noreferrer"
            data-testid="youtube-channel-cta"
            className="group relative block aspect-video bg-[#161616] border border-white/10 overflow-hidden"
          >
            <img
              src="https://images.unsplash.com/photo-1648428354557-e32892910fff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxtdXNpYyUyMHN0dWRpbyUyMGRhcmslMjBsaWdodGluZyUyMHNpbGhvdWV0dGV8ZW58MHx8fHwxNzc5MzIxMDU3fDA&ixlib=rb-4.1.0&q=85"
              alt="WOLF on YouTube"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/55 group-hover:bg-black/40 transition-colors" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full border border-white/40 flex items-center justify-center backdrop-blur-sm bg-black/30 group-hover:border-[#D4AF37] transition-colors">
                <Youtube size={36} className="text-white" />
              </div>
              <p className="font-display tracking-extreme text-white text-3xl sm:text-5xl mt-6">@WOLFMUSICAU</p>
              <p className="font-editorial italic text-white/65 mt-2 max-w-md">
                Music videos, live cuts, studio sessions. Watch on the channel.
              </p>
              <span className="mt-6 text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] inline-flex items-center gap-2 border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-4 py-2">
                Open on YouTube <ExternalLink size={12} />
              </span>
            </div>
          </a>
        </div>
      </div>

      {/* LYRICS / STORY DIALOG */}
      {active && (
        <div
          className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 sm:p-8"
          data-testid="lyrics-dialog"
          onClick={() => setActive(null)}
        >
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="relative max-w-3xl w-full bg-[#111111] border border-white/15 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setActive(null)}
              data-testid="lyrics-dialog-close"
              className="absolute top-4 right-4 text-white/60 hover:text-white p-2"
              aria-label="Close"
            >
              <X size={20} />
            </button>
            <div className="grid sm:grid-cols-5 gap-0">
              <img src={active.cover} alt={active.title} className="sm:col-span-2 w-full h-full object-cover aspect-square" />
              <div className="sm:col-span-3 p-7 sm:p-10">
                <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">{active.year} · {active.type}</p>
                <h3 className="font-display text-5xl sm:text-6xl text-white mt-3">{active.title}</h3>
                <p className="font-editorial italic text-white/65 mt-4">{active.description}</p>

                <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mt-8">— Story</p>
                <p className="font-body text-white/80 mt-3 leading-relaxed whitespace-pre-line">{active.story}</p>

                <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mt-8">— Lyric</p>
                <p className="font-editorial italic text-white/85 mt-3 whitespace-pre-line text-lg leading-relaxed">
                  {active.lyric}
                </p>

                {active.tracks && (
                  <div className="mt-8" data-testid="release-tracklist">
                    <p className="text-[10px] uppercase tracking-[0.32em] text-white/40">— Track List · {active.tracks.length} Songs</p>
                    <ol className="mt-3 grid sm:grid-cols-2 gap-x-8 gap-y-1.5">
                      {active.tracks.map((t, i) => (
                        <li key={t} className="flex items-baseline gap-3 text-sm text-white/75">
                          <span className="text-[10px] text-[#D4AF37]/70 font-display w-5 shrink-0 text-right">{i + 1}</span>
                          <span className="truncate">{t}</span>
                        </li>
                      ))}
                    </ol>
                  </div>
                )}

                <div className="flex flex-wrap gap-3 mt-10">
                  {active.bandlab ? (
                    <a href={active.bandlab} target="_blank" rel="noreferrer" className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37] border border-[#D4AF37]/50 hover:border-[#D4AF37] px-4 py-3 inline-flex items-center gap-2">
                      Listen Free on BandLab <ExternalLink size={12} />
                    </a>
                  ) : (
                  <>
                  <a href={active.spotify} target="_blank" rel="noreferrer" className="text-[10px] uppercase tracking-[0.32em] text-white border border-white/20 hover:border-[#D4AF37] px-4 py-3 inline-flex items-center gap-2">
                    Spotify <ExternalLink size={12} />
                  </a>
                  {active.appleSoon ? (
                    <span className="text-[10px] uppercase tracking-[0.32em] text-white/30 border border-white/10 px-4 py-3 inline-flex items-center gap-2 cursor-not-allowed">
                      Apple Music — Soon
                    </span>
                  ) : (
                  <a href={active.apple} target="_blank" rel="noreferrer" className="text-[10px] uppercase tracking-[0.32em] text-white border border-white/20 hover:border-[#D4AF37] px-4 py-3 inline-flex items-center gap-2">
                    Apple Music <ExternalLink size={12} />
                  </a>
                  )}
                  </>
                  )}
                  <a href={active.youtube} target="_blank" rel="noreferrer" className="text-[10px] uppercase tracking-[0.32em] text-white border border-white/20 hover:border-[#D4AF37] px-4 py-3 inline-flex items-center gap-2">
                    YouTube <ExternalLink size={12} />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}
